import React from 'react';
import { Typography } from '@material-ui/core';

function OxygenBatchConverter() {
  return (
    <div>
      <Typography variant="h5">
        Oxygen Batch Converter page is coming soon.
      </Typography>
    </div>
  );
}

export default OxygenBatchConverter;
